module.exports = __webpack_public_path__ + "static/img/bg5_1.a000c8c6.png";